import { render, staticRenderFns } from "./PerspectiveSelectorFilter.vue?vue&type=template&id=6b43c9cd&scoped=true&"
import script from "./PerspectiveSelectorFilter.vue?vue&type=script&lang=js&"
export * from "./PerspectiveSelectorFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b43c9cd",
  null
  
)

export default component.exports